import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import SecondaryCta from 'components/Buttons/SecondaryCta';
import { getOwnCartDrawerState } from 'styles/helpers/getSecondaryButtonState';
import { useDisableCartButtonsForGroupOrderGuest } from 'bento-ordering/group_ordering/hooks/index';

const CartItemActions = ({
  currentCartPath,
  editCartItemPath,
  onEditCartItem,
  onRemoveCartItem
}) => {
  const ownCartDrawerState = getOwnCartDrawerState();

  const disableCartButtonsForGroupOrderGuest = useDisableCartButtonsForGroupOrderGuest();

  return (
    <>
      <SecondaryCta
        component={Link}
        to={{
          pathname: editCartItemPath,
          state: {
            path: currentCartPath
          }
        }}
        handleClick={onEditCartItem}
        dataTestId="cart-item-edit-button"
        label="Edit"
        ownState={ownCartDrawerState}
        disabled={disableCartButtonsForGroupOrderGuest}
      />
      <SecondaryCta
        handleClick={onRemoveCartItem}
        dataTestId="cart-item-remove-button"
        label="Remove"
        ownState={ownCartDrawerState}
        disabled={disableCartButtonsForGroupOrderGuest}
      />
    </>
  );
};

CartItemActions.propTypes = {
  currentCartPath: PropTypes.string.isRequired,
  editCartItemPath: PropTypes.string.isRequired,
  onEditCartItem: PropTypes.func,
  onRemoveCartItem: PropTypes.func.isRequired
};

export default CartItemActions;
